import {makeDelta} from '../actions/flights'
import {compareDataOra, isContentInOrario, isFullTimeOrario} from '../../../../utils/helper'
import {toDateFromServer} from '../../../../utils/formatter'

const getAllFlightsFrom = function (state) {
  return makeDelta(state.flights.listFrom, state.flights.from)
}
const getFlightsFrom = function (state) {
  return getAllFlightsFrom(state).filter(function (item) {
    return applyFilter(state.flights.filterFrom, item)
  })
}

const getAllFlightsTo = function (state) {
  return makeDelta(state.flights.listTo, state.flights.to)
}

const getFlightsTo = function (state) {
  /* filtra i voli scegliendo solo quelli che hanno lo stesso vettore e la stessa data e ora di partenza nel volo di andata */
  const list = getAllFlightsTo(state).filter(item => {
    const from = state.flights.from
    return item.vector.objB === from.vector.objB && compareDataOra(from.voli[0].partenza.dataOra, item.partenzaFrom.dataOra)
  })
  return list
}

const applyFilter = function (filter, item) {
  if (filter.vector && filter.vector.objB !== item.vector.objB) return false
  if (!isFullTimeOrario(filter.orario) && isContentInOrario(filter.orario, makeOrarioFromFlight(item))) return false
  if (filter.partenza && filter.vector.partenza.value !== item.voli[0].partenza.airport.objB) return false
  if (filter.atterraggio && filter.vector.atterraggio.value !== item.voli[item.voli.length - 1].destinazione.airport.objB) return false
  // TODO: da rivedere il controllo se fatto su scali tecnici o effettivi
  if (filter.scalo && item.voli.length > 0 && (filter.scalo - 1) !== item.voli[0].scali.length) return false
  return true
}

const makeOrarioFromFlight = function (item) {
  const tmP = item.voli[0].partenza.dataOra.time.time
  const tmD = item.voli[item.voli.length - 1].destinazione.dataOra.time.time
  return [{h: tmP[0], m: tmP[1]}, {h: tmD[0], m: tmD[1]}]
}

const getFlightFrom = function (state) {
  return {...state.flights.from}
}

const getFlightFromLastDate = function (state) {
  const from = getFlightFrom(state)
  if (from && from.voli) {
    return toDateFromServer(from.voli[from.voli.length - 1].destinazione.dataOra.date.date)
  }
  return null
}

const getFlightTo = function (state) {
  return {...state.flights.to}
}

const getFlightsCounter = function (state) {
  const {from, to} = state.flights
  let cnt = from ? 1 : 0
  cnt += to ? 1 : 0
  return cnt
}

const getFlexibleDates = function (state) {
  return [...state.flights.flexibleDates]
}

const getFlightVectorsFrom = function (state) {
  return getFlightVectors(state.flights.listFrom)
}

const getFlightVectorsTo = function (state) {
  return getFlightVectors(state.flights.listTo)
}

const getFlightVectors = function (list) {
  return [...new Set(list.map(function (item) {
    return item.vector
  }))]
}

const getFlightFilterFrom = function (state) {
  return {...state.flights.filterFrom}
}

const getFlightFilterTo = function (state) {
  return {...state.flights.filterTo}
}

export default {
  getFlightFromLastDate,
  getAllFlightsFrom,
  getAllFlightsTo,
  getFlightsFrom,
  getFlightsTo,
  getFlightFrom,
  getFlightTo,
  getFlightsCounter,
  getFlexibleDates,
  getFlightVectorsFrom,
  getFlightVectorsTo,
  getFlightFilterFrom,
  getFlightFilterTo
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/flight.js